import { defineComponent as _defineComponent } from 'vue'
import { Game } from '@/models/Game'
import { ref } from 'vue'
  

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsGameInputsModal',
  emits: ['cancel', 'save'],
  setup(__props, { expose, emit }) {


const game = ref<Game | null>(null)

const showModal = (g: Game) => {
  game.value = g
}

const hideModal = () => {
  game.value = null
}



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cancel = () => {
  emit('cancel', game.value)
  hideModal()
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const save = () => {
  emit('save', game.value)
  hideModal()
}

expose({ showModal, hideModal });


const __returned__ = { game, showModal, hideModal, emit, cancel, save, Game, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})